import { scrollToElement } from "@modules/util/scrolling-utilities"

const moreContentCalculators: Array<() => void> = []

export const calculateMoreContentHeights: () => void = (): void => {
    for (const calculatorCallback of moreContentCalculators) {
        calculatorCallback()
    }
}

const fkkSpecialsMoreButtons: () => NodeListOf<HTMLElement> = (): NodeListOf<HTMLElement> =>
    document.querySelectorAll(".fkk-specials .more-button")

const registerButtonEvent: (button: HTMLElement, moreContentSection: HTMLElement) => void = (
    button: HTMLElement,
    moreContentSection: HTMLElement,
): void => {
    button.addEventListener("click", (event: MouseEvent): void => {
        event.preventDefault()
        event.stopPropagation()

        moreContentSection.classList.toggle("more-is-open")

        const moreContentElement: HTMLElement | null = moreContentSection.querySelector(".more-content")
        if (moreContentSection.classList.contains("more-is-open") || moreContentElement === null) {
            return
        }

        scrollToElement(moreContentElement, { duration: 500, offset: 200 })
    })
}

export function initializeSpecialsMoreButtons(): void {
    const buttons: NodeListOf<HTMLElement> = fkkSpecialsMoreButtons()

    for (const button of buttons) {
        const moreElementId: string = button.dataset.opens || ""
        if (moreElementId === "") {
            console.warn("Button has no container reference, attribute data-opens is missing.")
            return
        }

        const moreContentSection: HTMLElement | null = document.getElementById(moreElementId)
        if (!moreContentSection) {
            console.warn(`Element with id "${moreElementId}" not found. Unable to open more container.`)
            return
        }

        moreContentCalculators.push((): void => {
            const contentHeight: number = Math.ceil(
                moreContentSection.querySelector(".more-content")?.getBoundingClientRect().height || 0,
            )
            moreContentSection.setAttribute("style", `--height--more-container: ${contentHeight}px;`)
        })

        registerButtonEvent(button, moreContentSection)
    }
}
